import axios from 'axios'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  getConfiguration({ commit }, params = {}) {
    return axios.get('/xero/configurations', { params })
  },
  connect({ commit }, data) {
    return axios.post('/xero/account/connect', data)
  },
  disconnect({ commit }) {
    return axios.post('/xero/account/disconnect')
  },
  getAccoutCodes({ commit }, params = {}) {
    return axios.get('/xero/account-codes', { params })
  },
  updateAccoutCodes({ commit }, data) {
    return axios.post('/xero/account-codes/config', data)
  },
  syncAccoutCodes({ commit }) {
    return axios.post('/xero/account-codes/sync')
  },
  getAccountCodesDefaults({ commit }, params = {}) {
    return axios.get('/business-configurations', { params })
  },
}
